(function () {
  function initQuiz(root) {
    if (!root || root.dataset.eliteQuizReady === 'true') return;
    root.dataset.eliteQuizReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var resultPanels = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-result]'));
    var progress = root.querySelector('[data-quiz-progress]');
    var progressText = root.querySelector('[data-quiz-progress-text]');
    var backButton = root.querySelector('[data-quiz-back]');
    var restartButtons = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-restart]'));
    var quizPanel = root.querySelector('[data-quiz-panel]');
    var resultsWrap = root.querySelector('[data-quiz-results]');
    var currentStep = 0;
    var answers = [];

    function updateProgress() {
      var total = Math.max(steps.length, 1);
      var value = Math.round(((currentStep + 1) / total) * 100);
      if (progress) progress.style.width = value + '%';
      if (progressText) progressText.textContent = 'Question ' + (currentStep + 1) + ' of ' + total;
      if (backButton) {
        backButton.hidden = currentStep === 0;
        backButton.style.display = currentStep === 0 ? 'none' : '';
      }
    }

    function showStep(index) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function (step, i) {
        step.hidden = i !== currentStep;
      });
      if (quizPanel) quizPanel.hidden = false;
      if (resultsWrap) resultsWrap.hidden = true;
      resultPanels.forEach(function (panel) {
        panel.hidden = true;
      });
      updateProgress();
    }

    function chooseResult() {
      var scores = {};
      answers.forEach(function (key) {
        if (!key) return;
        scores[key] = (scores[key] || 0) + 1;
      });

      var bestKey = answers[answers.length - 1] || 'smooth';
      Object.keys(scores).forEach(function (key) {
        if (scores[key] > (scores[bestKey] || 0)) bestKey = key;
      });

      return bestKey;
    }

    function showResult() {
      var key = chooseResult();
      var panel = root.querySelector('[data-quiz-result="' + key + '"]') || resultPanels[0];
      if (quizPanel) quizPanel.hidden = true;
      if (resultsWrap) resultsWrap.hidden = false;
      resultPanels.forEach(function (item) {
        item.hidden = item !== panel;
      });

      root.dispatchEvent(new CustomEvent('elite:coffee-quiz-result', {
        bubbles: true,
        detail: { result: key, answers: answers.slice() }
      }));
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-quiz-option]');
      if (!option || !root.contains(option)) return;
      answers[currentStep] = option.getAttribute('data-result-key');
      if (currentStep + 1 >= steps.length) {
        showResult();
      } else {
        showStep(currentStep + 1);
      }
    });

    if (backButton) {
      backButton.addEventListener('click', function () {
        if (currentStep > 0) showStep(currentStep - 1);
      });
    }

    restartButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        answers = [];
        showStep(0);
      });
    });

    if (steps.length) showStep(0);
  }

  function initAll() {
    document.querySelectorAll('[data-elite-coffee-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
